import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import Translator from "Languages/Utility/Translator";
import { Dialog, DialogActions, DialogContent } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { satc_accountingHistoryIncTimeGroup } from "Constants/TableColumns";
import * as Icons from "react-bootstrap-icons";
import addNumToList from "Helpers/addNumToList";
import MuiButton from "Components/MuiButton/MuiButton";
import RemoteTable from "Components/RemoteTable/RemoteTable";

export default function IncTimeGroup({ row }) {
  const { direction } = useTheme();
  const [showDialog, setShowDialog] = useState(false);
  const onShowDialog = () => {
    setShowDialog(true);
  };
  return (
    <>
      <ActionFormatter
        title={<Translator id="groups" />}
        icon={<Icons.PersonLinesFill />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={() => setShowDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <div className="dialogHeader justify-content-start">
          <p>
            <Translator id="groups" />
            {" - "}
            <Translator id="sati_UserRegister" />
            {" : "}
            <strong>{`${row.UserRegister}`}</strong>
          </p>
        </div>
        <DialogContent>
          <RemoteTable
            data={addNumToList(row.Groups, 1, 0)}
            columns={satc_accountingHistoryIncTimeGroup}
            showPagination={false}
          />
        </DialogContent>
        <DialogActions>
          <MuiButton
            onClick={() => setShowDialog(false)}
            title={<Translator id="close" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
